<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1" id="title"><a id="page_iii"></a><strong>SCIENTISTS &amp;</strong><br/>SWINDLERS</h1>
<p class="subtitle"><span class="smallcaps">CONSULTING ON COAL AND OIL</span><br/><span class="smallcaps">IN AMERICA</span> <strong>,</strong> 1820–1890 <img alt="images" src="images/f0iii-01.jpg"/></p>
<p class="authorleft"><em>Paul Lucier</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm03_tit.vue?a959f308